"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function arrayReducedEqualsValidationRule(_a, path, context) {
    var index = _a.index, messages = _a.messages, schema = _a.schema;
    var src = [];
    if (!context.customs[index]) {
        context.customs[index] = { schema: schema };
    }
    else {
        context.customs[index].schema = schema;
    }
    src.push("const reduced = context.customs[" + index + "].schema.reducer(value);");
    src.push("const res = context.customs[" + index + "].schema.comparator(parent, reduced);");
    src.push("if (!res) {");
    src.push("  " + this.makeError({ actual: 'value', expected: 'reduced', messages: messages, type: 'arrayReducedEquals' }) + ";");
    src.push('return;');
    src.push('}');
    src.push('return value;');
    return {
        source: src.join('\n'),
    };
}
exports.default = arrayReducedEqualsValidationRule;
//# sourceMappingURL=arrayReducedEqualsValidationRule.js.map